<template lang="pug">
  div.drawer-list-container
    // .drawer-list__mobile(v-if="$vuetify.breakpoint.smAndDown")
      img(src="@/assets/csfs-logo-new.svg")
    v-list.drawer-list(expand)
      v-list-group(active-class="active")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon play_circle_filled
          v-list-tile-content
            v-list-tile-title Getting Started
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") Getting Started
              div(slot="content")
                p The Getting Started tool provides a quick reference guide that describes how to use the Colorado Wildfire Risk Viewer application. It specifically demonstrates how to explore risk assessment map themes, identify a location of interest, and identify fire intensity for a specific location of interest.
                p Refer to the Wildfire Risk Viewer User Manual under Support for detailed help.
        getting-started
      v-list-group(active-class="active" :value="true")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon whatshot
          v-list-tile-content
            v-list-tile-title.v-step-4 Identify Fire Intensity
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") Identify Fire Intensity
              div(slot="content")
                p The Identify Fire Intensity tool summarizes the potential fire intensity under high to extreme weather conditions for any specific location of interest. It is intended to inform homeowners and business owners of the impending risk for their location based on surrounding conditions.
                p It allows you to draw a point on the map and automatically retrieve this information for a quarter-mile buffer. A quarter-mile buffer is used because risk from wildfire is dependent on the conditions surrounding a location, not the conditions at specific site. The information is summarized and presented to you for review. A link is also provided to connect you to the Colorado State Forest Service mitigation web site where more information can be obtained.
                p Refer to the Wildfire Risk Viewer User Manual under Support for detailed help.
        identify-fire-intensity

      v-list-group(active-class="active")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon assignment
          v-list-tile-content
            v-list-tile-title.v-step-7 County Summary
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") County Summary
              div(slot="content")
                p The County Summary tool allows users to select a county and view that county's WUI Risk Infosheet. The infosheet will be opened in a new tab where users can save or print the PDF document.
        county-summary

      v-list-group.v-step-5(active-class="active")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon layers
          v-list-tile-content
            v-list-tile-title Reference Layers
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") View Reference Layers
              div(slot="content")
                p The Reference Layers tool allows you to view and activate standard map layers such as county and city boundaries. More than one Reference Layer can be selected at once. Once activated the reference layer will be visible on the map.
                p Refer to the Wildfire Risk Viewer User Manual under Support for detailed help.
        reference-layers
      v-list-group(active-class="active" :value="true")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon map
          v-list-tile-content
            v-list-tile-title.v-step-6 Explore Map Themes
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") Explore Map Themes
              div(slot="content")
                p The Map Themes tool allows you to view and activate key map layers.
                p Map themes are broken into a variety of categories for easier navigation. You can view different wildfire risk information by selecting any of the available map themes/layers. You can only have one active map theme at a time.
                p Click on any theme/layer to turn it on. Information about the selected map theme/layer will be shown at the bottom of the toolbox.
                p You can show the legend, get a full detailed description and adjust the transparency of the selected map theme/layer.
                p Refer to the Wildfire Risk Viewer User Manual under Support for detailed help.
        map-themes

      v-list-group(active-class="active")
        v-list-tile(slot="activator")
          v-list-tile-avatar
            v-icon print
          v-list-tile-content
            v-list-tile-title.v-step-8 Print Map
          v-list-tile-action
            help-pop-up(icon="help" title="Help")
              v-btn(icon slot="activator")
                v-icon(disabled) help
              h3(slot="content-header") Print Map
              div(slot="content")
                p The Print Map tool allows you to create a simple map matching the contents of your browser. The map is created as a PDF and is available for download. You can enter in a Title and Subtitle for the map to customize it.
                p Press Print to select an area on the map and generate the PDF document.
                p Refer to the Wildfire Risk Viewer User Manual under Support for detailed help.
        print-map
</template>

<script>
import GettingStarted from '@/components/GettingStarted'
import ReferenceLayers from '@/components/ReferenceLayers'
import MapThemes from '@/components/MapThemes'
import IdentifyFireIntensity from '@/components/IdentifyFireIntensity'
import PrintMap from '@/components/PrintMap'
import HelpPopUp from '@/components/HelpPopUp'
import CountySummary from '@/components/CountySummary'

export default {
  components: { GettingStarted, ReferenceLayers, MapThemes, PrintMap, HelpPopUp, IdentifyFireIntensity, CountySummary }
}
</script>

<style lang="stylus">
  .drawer-list
    .v-list__tile
      width 250px
      padding-right 0
      &__title
        font-weight bold
        color #333333
        font-size 14px
      .v-list__tile__action
        min-width 30px
    .v-list__group__header
      &__append-icon
        padding-left 0
      &--active
        // color #DEC68A
        .v-avatar i
          color #DEC68A
</style>

<style lang="stylus">
  .drawer-list
    .v-list__tile
      width 250px
      padding-right 0
    &__mobile
      background-color #004F27
      padding 2em
      display flex
      align-items center
      justify-content center
      img
        width 150px
</style>
